
/* Format price with comma separators */
function formatMoney(cents) {
  var amount = (parseFloat(cents) / 100);
  return '$' + amount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}
/* ============================================================
   IRON ELK EQUIPMENT - Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* Mobile Menu Toggle */
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mainNav = document.querySelector('.main-nav');
  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', function() {
      mainNav.classList.toggle('active');
      this.setAttribute('aria-expanded', mainNav.classList.contains('active'));
    });
  }

  /* Product Tabs */
  const tabBtns = document.querySelectorAll('.product-tab-btn');
  const tabContents = document.querySelectorAll('.product-tab-content');
  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const target = this.dataset.tab;
      tabBtns.forEach(function(b) { b.classList.remove('active'); });
      tabContents.forEach(function(c) { c.classList.remove('active'); });
      this.classList.add('active');
      const panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  /* Product Image Gallery */
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  const mainImage = document.querySelector('.product-main-image img');
  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbnails.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (mainImage) {
        mainImage.src = this.dataset.fullSrc || this.querySelector('img').src;
        mainImage.alt = this.querySelector('img').alt;
      }
    });
  });

  /* Variant Selector */
  const variantSelect = document.querySelector('.product-variant-select');
const mpnEl = document.querySelector('#product-mpn');
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      const selected = this.options[this.selectedIndex];
      const price = selected.dataset.price;
      const comparePrice = selected.dataset.comparePrice;
      const available = selected.dataset.available === 'true';
      const priceEl = document.querySelector('.product-price');
      const addBtn = document.querySelector('.add-to-cart-btn');
      const variantInput = document.querySelector('input[name="id"]');

      /* Update MPN */
    var sku = selected.dataset.sku;
    if (mpnEl && sku) {
      mpnEl.textContent = 'MPN: ' + sku;
    }
    if (priceEl && price) {
        priceEl.innerHTML = formatMoney(price);
        if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
          priceEl.innerHTML += ' <span class="compare-price">' + formatMoney(comparePrice) + '</span>';
        }
      }
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
      if (variantInput) {
        variantInput.value = this.value;
      }
    });
  }

  /* Cart Quantity Buttons */
  document.querySelectorAll('.cart-qty button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const input = this.parentElement.querySelector('input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.classList.contains('qty-minus')) {
        val = Math.max(0, val - 1);
      } else {
        val += 1;
      }
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* Auto-link phone numbers and emails */
  function autoLinkContactInfo() {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    const phoneRegex = /\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/g;
    const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement && 
          !['A', 'SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT'].includes(node.parentElement.tagName)) {
        if (phoneRegex.test(node.textContent) || emailRegex.test(node.textContent)) {
          nodes.push(node);
        }
        phoneRegex.lastIndex = 0;
        emailRegex.lastIndex = 0;
      }
    }
    nodes.forEach(function(node) {
      let html = node.textContent;
      html = html.replace(phoneRegex, function(match) {
        const digits = match.replace(/\D/g, '');
        return '<a href="tel:+1' + digits + '">' + match + '</a>';
      });
      html = html.replace(emailRegex, function(match) {
        return '<a href="mailto:' + match + '">' + match + '</a>';
      });
      if (html !== node.textContent) {
        const span = document.createElement('span');
        span.innerHTML = html;
        node.parentElement.replaceChild(span, node);
      }
    });
  }
  autoLinkContactInfo();

  /* Wrap product description tables in scrollable containers */
  document.querySelectorAll('.product-description-styled table').forEach(function(table) {
    if (!table.parentElement.classList.contains('table-scroll-wrapper')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'table-scroll-wrapper';
      wrapper.style.overflowX = 'auto';
      wrapper.style.webkitOverflowScrolling = 'touch';
      wrapper.style.margin = '20px 0 28px';
      table.parentElement.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  });

  /* Recently Viewed Products - Track */
  (function() {
    var productPage = document.querySelector('.product-page');
    if (productPage && window.location.pathname.indexOf('/products/') !== -1) {
      var handle = window.location.pathname.split('/products/')[1];
      if (handle) {
        handle = handle.split('?')[0].split('#')[0];
        var viewed = JSON.parse(localStorage.getItem('ironelk_recently_viewed') || '[]');
        viewed = viewed.filter(function(h) { return h !== handle; });
        viewed.unshift(handle);
        if (viewed.length > 12) viewed = viewed.slice(0, 12);
        localStorage.setItem('ironelk_recently_viewed', JSON.stringify(viewed));
      }
    }
  })();

  /* Recently Viewed Products - Render */
  (function() {
    var container = document.querySelector('.recently-viewed-products');
    if (!container) return;
    var viewed = JSON.parse(localStorage.getItem('ironelk_recently_viewed') || '[]');
    var currentHandle = window.location.pathname.split('/products/')[1];
    if (currentHandle) currentHandle = currentHandle.split('?')[0].split('#')[0];
    viewed = viewed.filter(function(h) { return h !== currentHandle; });
    if (viewed.length === 0) {
      container.closest('section').style.display = 'none';
      return;
    }
    var toShow = viewed.slice(0, 4);
    var fetched = 0;
    var html = '';
    toShow.forEach(function(handle) {
      fetch('/products/' + handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var p = data.product;
          var img = p.image ? p.image.src : '';
          var price = formatMoney(p.variants[0].price * 100);
          html += '<div class="product-card">';
          html += '<a href="/products/' + p.handle + '" class="product-card-image">';
          if (img) html += '<img src="' + img + '" alt="' + p.title + '" loading="lazy">';
          html += '</a>';
          html += '<div class="product-card-info">';
          html += '<p class="product-card-vendor">' + (p.vendor || '') + '</p>';
          html += '<h3 class="product-card-title"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>';
          html += '<p class="product-card-price">' + price + '</p>';
          html += '</div></div>';
          fetched++;
          if (fetched === toShow.length) {
            container.innerHTML = html;
          }
        })
        .catch(function() { fetched++; });
    });
  })();

  /* Collection Sort */
  const sortSelect = document.querySelector('.collection-sort select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

});
